module.exports = __webpack_public_path__ + "81a6b811648f005399e858b0a7183f45.glb";